var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('adressItem',{attrs:{"itemField":'area',"refs":_vm.refs}}),_c('adressItem',{attrs:{"itemField":'city',"refs":_vm.refs}}),_c('adressItem',{attrs:{"itemField":'street',"refs":_vm.refs}}),_c('adressItem',{attrs:{"itemField":'house',"refs":_vm.refs}}),_c('adressItem',{attrs:{"itemField":'deportament',"refs":_vm.refs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }